export const environment = {
    
    production: false,
    url: '',
    ApiAppUrl: 'https://feadminapitest.clavisco.com/',
    env: 'Testing',

}